import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPeople = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 3.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M3 8a3 3 0 0 0-3 3v4h8V8zm10 0h-3v7h6v-4a3 3 0 0 0-3-3m-1-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
	})
});
export default SvgPeople;
